import { render, staticRenderFns } from "./charteredOrder.vue?vue&type=template&id=5c96943c&scoped=true"
import script from "./charteredOrder.vue?vue&type=script&lang=js"
export * from "./charteredOrder.vue?vue&type=script&lang=js"
import style0 from "./charteredOrder.vue?vue&type=style&index=0&id=5c96943c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96943c",
  null
  
)

export default component.exports